if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        // Preserve the disabled status rendered by Liquid for sold-out variants.
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        const muAvailabilityData = this.querySelector('[data-mu-variant-purchasability]');
        this.muVariantPurchasability = null;
        if (muAvailabilityData) {
          try {
            this.muVariantPurchasability = JSON.parse(muAvailabilityData.textContent);
          } catch (error) {
            console.warn('Mu Shop: invalid variant purchase availability data', error);
          }
        }
        this.variantIdInput?.addEventListener('change', () => this.syncMuPurchaseState());
        this.syncMuPurchaseState();

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (
          this.submitButton.disabled ||
          this.variantIdInput?.disabled ||
          this.muCanPurchaseSelectedVariant() === false ||
          this.submitButton.getAttribute('aria-disabled') === 'true'
        ) {
          this.syncMuPurchaseState();
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && !this.submitButton.disabled && this.muCanPurchaseSelectedVariant() !== false) {
              this.submitButton.removeAttribute('aria-disabled');
            }
            this.syncMuPurchaseState();
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      muCanPurchaseSelectedVariant() {
        if (!this.muVariantPurchasability) return null;
        const id = this.variantIdInput?.value;
        return id ? this.muVariantPurchasability[id] === true : false;
      }

      syncMuPurchaseState() {
        const canPurchase = this.muCanPurchaseSelectedVariant();
        if (canPurchase === null) return; // Other forms: preserve standard Dawn handling.

        // A native disabled control cannot submit, even if a theme script changes CSS.
        this.toggleSubmitButton(!canPurchase, canPurchase ? undefined : (window.variantStrings?.soldOut || 'Sold out'));
        if (this.variantIdInput) this.variantIdInput.disabled = !canPurchase;
      }

      toggleSubmitButton(disable = true, text) {
        // Liquid's per-variant data prevents other callbacks enabling a sold-out variant.
        if (this.muCanPurchaseSelectedVariant() === false) disable = true;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.submitButton.setAttribute('aria-disabled', 'true');
          if (text) this.submitButtonText.textContent = text;
          else if (this.muCanPurchaseSelectedVariant() === false) {
            this.submitButtonText.textContent = window.variantStrings?.soldOut || 'Sold out';
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
          this.submitButtonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
